import { canUseDom } from "./can-use-dom";
var tenPxTester = null;
var tester = null;
if (canUseDom) {
  tenPxTester = document.createElement("div");
  tenPxTester.className = "tc-px-tester";
  tenPxTester.style.setProperty("--size", "10");
  document.body.appendChild(tenPxTester);
  tester = document.createElement("div");
  tester.className = "tc-px-tester";
  document.body.appendChild(tester);
}
export function convertPx(px) {
  if (tenPxTester === null || tester === null) return px;
  if (tenPxTester.getBoundingClientRect().height === 10) {
    return px;
  }
  tester.style.setProperty("--size", px.toString());
  return tester.getBoundingClientRect().height;
}